export default __webpack_public_path__ + "static/media/R_wdt_c_cap_4.6b4cd0e0.mp3";